import { USER_CONTEXT, SUPER_ADMIN_ROLES } from "../../../../constants";

/**
 * Tab config for Admin User Profile (CC-13942 access matrix).
 *
 * New UI (createStaffV2Enabled):
 * - Superadmin viewing own: Learner Groups only.
 * - Superadmin viewing another Superadmin: no tabs.
 * - Superadmin viewing other roles: Facilities only.
 * - Non-Superadmin: Facilities; + Learner Groups when viewing own.
 *
 * Legacy UI: Details, Relationship, Roles, + Learner Groups when own, + Communication for Superadmin/Facility Admin.
 */

const TAB_FACILITIES = (allTabs) => ({ id: allTabs.Roles, label: "Facilities", icon: "flag" });
const TAB_LEARNER_GROUPS = (allTabs, icon = null) => ({ id: allTabs.Learner_Group, label: "Learner Groups", ...(icon && { icon }) });

function buildNewTabs({ allTabs, isViewingOwnProfile, isSuperAdmin, profileIsSuperAdmin }) {
    if (isSuperAdmin) {
        if (isViewingOwnProfile) return [TAB_LEARNER_GROUPS(allTabs)];
        if (profileIsSuperAdmin) return [];
        return [TAB_FACILITIES(allTabs)];
    }
    const tabs = [TAB_FACILITIES(allTabs)];
    if (isViewingOwnProfile) tabs.push(TAB_LEARNER_GROUPS(allTabs, "group"));
    return tabs;
}

function buildLegacyTabs({ allTabs, isViewingOwnProfile, isSuperAdmin, isFacilityAdmin, isDisableV1MessagingEnabled }) {
    const tabs = [
        { id: allTabs.Details, label: "Details" },
        { id: allTabs.Relationship, label: "Relationship" },
        { id: allTabs.Roles, label: "Roles" },
    ];
    if (isViewingOwnProfile) tabs.push({ id: allTabs.Learner_Group, label: "Learner Groups" });
    if (isSuperAdmin || isFacilityAdmin) tabs.splice(1, 0, { id: allTabs.Communication, label: "Communication" });
    if (isDisableV1MessagingEnabled) {
        return tabs.filter((t) => t.id !== allTabs.Relationship && t.id !== allTabs.Communication);
    }
    return tabs;
}

const useTabDetailsHook = ({
    profileId,
    allTabs,
    global,
    isDisableV1MessagingEnabled,
    roleType,
    createStaffV2Enabled,
}) => {
    const isViewingOwnProfile = profileId != null && String(profileId) === String(USER_CONTEXT.personId);
    const isSuperAdmin = Boolean(global?.isSuperAdmin);
    const isFacilityAdmin = Boolean(global?.isFacilityAdmin);
    const profileIsSuperAdmin = roleType != null && SUPER_ADMIN_ROLES.includes(roleType);

    if (Boolean(createStaffV2Enabled)) {
        return buildNewTabs({ allTabs, isViewingOwnProfile, isSuperAdmin, profileIsSuperAdmin });
    }

    return buildLegacyTabs({
        allTabs,
        isViewingOwnProfile,
        isSuperAdmin,
        isFacilityAdmin,
        isDisableV1MessagingEnabled,
    });
};

export default useTabDetailsHook;
